import React from 'react';
import { connect } from 'react-redux';

// 3rd Party
import Slider from 'react-slick'
import { cdnHost } from './../../settings';

const NextArrow = props => {
  const { className, style, onClick } = props;

  return (
    <div className="arrow-wrap">
      <div
        className={className}
        style={{ ...style, display: 'block' }}
        onClick={onClick}
      >next</div>
    </div>
  );
};

const PrevArrow = props => {
  const { className, style, onClick } = props;

  return (
    <div className="arrow-wrap">
      <div
        className={className}
        style={{ ...style, display: 'block' }}
        onClick={onClick}
      >prev</div>
    </div>
  );
};

const mapStateToProps = state => ({ isMobile: state.isMobile });

class SlideShow extends React.Component {
  constructor(props) {
    super(props);

    let images = [];

    if (props.isMobile) {
      images = this.props.content.images_mobile;
    } else {
      images = this.props.content.images;
    }

    this.state = {
      images,
      isMobile: props.isMobile,
      sliderSettings: {
        adaptiveHeight: false,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
        centerMode: true,
        centerPadding: 0,
        dots: true,
        nextArrow: <NextArrow />,
        pauseOnHover: true,
        prevArrow: <PrevArrow />,
        responsive: [
          {
            breakpoint: 640,
            settings: { arrows: false }
          }
        ],
        slidesToScroll: 1,
        slidesToShow: 1
      }
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isMobile !== nextProps.isMobile) {
      this.setState({ isMobile: nextProps.isMobile });

      if (nextProps.isMobile) {
        this.setState({ images: this.props.content.images_mobile });
      } else {
        this.setState({ images: this.props.content.images });
      }
    }
  }

  render() {
    return (
      <section className="slider">
        <header>
          <h2>{this.props.content.heading}</h2>
        </header>
        <Slider {...this.state.sliderSettings}>
        {this.state.images.map((image, index) =>
          <div key={index}>
            <div className="impression-image" style={{ backgroundImage: `url('${require(`../../../public/content/assets/${image}`)}')`, backgroundSize: 'cover', height: '100%', width: '100%' }}></div>
          </div>
        )}
        </Slider>
      </section>
    );
  }
}

export default connect(mapStateToProps)(SlideShow);


// WEBPACK FOOTER //
// ./src/sections/slide-show/slide-show.jsx